import React from 'react';

interface VideoData {
  id: string;
  task_id: string;
  type: string;
  data: string;
  output: string | object;
  created_at: string;
  email: string;
  is_featured?: boolean;
  is_paid?: boolean;
}

interface SimpleVideoCardProps {
  video: VideoData;
  index: number;
}

const SimpleVideoCard: React.FC<SimpleVideoCardProps> = ({ video, index }) => {
  return (
    <div className="group relative bg-gray-800 rounded-2xl p-4 border border-gray-700">
      <div className="aspect-video bg-gray-900 rounded-xl mb-3 flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl mb-2">🎬</div>
          <p className="text-xs text-gray-400">Video {index + 1}</p>
        </div>
      </div>
      
      <div className="space-y-2">
        <div className="text-sm font-medium text-white">
          ID: {video.task_id}
        </div>
        <div className="text-xs text-gray-400">
          Type: {video.type}
        </div>
        <div className="text-xs text-gray-400">
          Email: {video.email}
        </div>
        <div className="text-xs text-gray-400">
          Created: {new Date(video.created_at).toLocaleDateString()}
        </div>
        {video.is_featured && (
          <div className="text-xs text-green-400">
            ⭐ Featured
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleVideoCard; 